import React from 'react';

const H1: React.CSSProperties = { fontSize: 26, fontWeight: 800, margin: '0 0 6px', color: '#0E1A1A' };
const SUB: React.CSSProperties = { margin: 0, fontSize: 14, color: '#66748B', maxWidth: 560 };
const PAGE_HEAD: React.CSSProperties = {
  display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
  gap: 24, marginBottom: 22,
};
const BTN: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 8,
  background: '#0E1A1A', color: '#FFFFFF',
  fontSize: 14, fontWeight: 600, padding: '11px 18px',
  borderRadius: 10, border: 0, cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(14,26,26,.12)',
};
const BTN_GHOST: React.CSSProperties = {
  ...BTN, background: '#FFFFFF', color: '#0E1A1A',
  border: '1px solid #E7EAF0', boxShadow: 'none',
};
const TOOLBAR: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  background: '#FFFFFF', border: '1px solid #E7EAF0',
  borderRadius: '14px 14px 0 0', padding: '12px 18px', borderBottom: 0,
};
const CHIP: React.CSSProperties = {
  fontSize: 12.5, padding: '6px 12px', borderRadius: 999,
  color: '#66748B', background: '#F7F8FA', cursor: 'pointer',
};
const CHIP_ACTIVE: React.CSSProperties = {
  ...CHIP, background: '#0E1A1A', color: '#FFFFFF', fontWeight: 600,
};
const EMPTY_CARD: React.CSSProperties = {
  background: '#FFFFFF', border: '1px solid #E7EAF0', borderTop: 0,
  borderRadius: '0 0 14px 14px',
  display: 'flex', alignItems: 'stretch', overflow: 'hidden',
};
const ILL_WRAP: React.CSSProperties = {
  flex: '0 0 auto',
  width: 320,
  padding: '48px 20px',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: '#FFFFFF',
};
const COPY: React.CSSProperties = {
  flex: 1,
  padding: '52px 48px 60px',
  background: '#F3EBFC',
  display: 'flex', flexDirection: 'column', justifyContent: 'center',
};
const COPY_H2: React.CSSProperties = { fontSize: 30, fontWeight: 800, margin: '0 0 14px', lineHeight: 1.15 };
const COPY_P: React.CSSProperties = { fontSize: 15, color: '#66748B', lineHeight: 1.65, margin: '0 0 22px' };
const STEPS: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: 14, margin: '22px 0 26px' };
const STEP: React.CSSProperties = {
  display: 'flex', alignItems: 'flex-start', gap: 12,
  fontSize: 13.5, color: '#0E1A1A', lineHeight: 1.5,
};
const STEP_N: React.CSSProperties = {
  width: 22, height: 22, background: '#FFFFFF', color: '#6B46C1',
  borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontWeight: 800, fontSize: 11, flexShrink: 0, marginTop: 1,
};

const steps = [
  { b: 'Send invoices or payment links', d: 'Both routes land in Novala Pay.' },
  { b: 'Customer pays by card, bank, or Interac', d: 'We route funds through Novala Pay.' },
  { b: 'Payouts land in your bank in 1 to 2 business days', d: 'Tracked here with the invoice they came from.' },
];

export default function Payouts() {
  return (
    <div>
      <div style={PAGE_HEAD}>
        <div>
          <h1 style={H1}>Payouts</h1>
          <p style={SUB}>Money paid to you through Novala Pay, grouped by the day it lands in your bank.</p>
        </div>
        <button type="button" style={BTN_GHOST}>See payout schedule</button>
      </div>

      <div style={TOOLBAR}>
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={CHIP_ACTIVE}>All payouts</div>
          <div style={CHIP}>Pending</div>
          <div style={CHIP}>In transit</div>
          <div style={CHIP}>Paid</div>
        </div>
      </div>

      <div style={EMPTY_CARD}>
        <div style={ILL_WRAP}>
          <svg viewBox="0 0 320 320" width="100%" height="100%" aria-hidden="true">
            <ellipse cx="160" cy="175" rx="145" ry="135" fill="#EDE4FA"/>
            <circle cx="240" cy="60" r="30" fill="#D9C7F0" opacity="0.7"/>
            <circle cx="60" cy="90" r="18" fill="#D9C7F0" opacity="0.6"/>

            <g transform="translate(185, 60)">
              <rect x="0" y="0" width="85" height="60" rx="6" fill="#FFFFFF" stroke="#E7EAF0" strokeWidth="1"/>
              <text x="6" y="12" fontSize="7" fontWeight="700" fill="#6B46C1">Payouts, 7d</text>
              <rect x="8" y="42" width="8" height="10" rx="1" fill="#C4B5FD"/>
              <rect x="22" y="36" width="8" height="16" rx="1" fill="#A78BFA"/>
              <rect x="36" y="26" width="8" height="26" rx="1" fill="#8B5CF6"/>
              <rect x="50" y="30" width="8" height="22" rx="1" fill="#8B5CF6"/>
              <rect x="64" y="18" width="8" height="34" rx="1" fill="#6B46C1"/>
              <path d="M 10 48 Q 40 20 70 15" stroke="#15A08C" strokeWidth="1.5" fill="none" strokeDasharray="2,2"/>
              <polygon points="70,15 66,13 68,19" fill="#15A08C"/>
              <text x="78" y="12" textAnchor="end" fontSize="8" fontWeight="800" fill="#0F172A">+$3,937</text>
            </g>

            {/* Mix B: teal arrow (large), purple card (medium), coral arrow (small) */}
            <circle cx="60" cy="150" r="14" fill="#15A08C"/>
            <path d="M 60 143 L 60 156 M 55 150 L 60 156 L 65 150" stroke="#FFFFFF" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            <g transform="translate(265, 195) rotate(-6)">
              <rect x="-16" y="-10" width="32" height="20" rx="3" fill="#8B5CF6"/>
              <rect x="-16" y="-7" width="32" height="4" fill="#6B46C1"/>
              <rect x="-12" y="2" width="7" height="4" rx="0.5" fill="#F6C84C"/>
            </g>
            <circle cx="275" cy="140" r="8" fill="#F97066"/>
            <path d="M 275 136 L 275 143 M 272 141 L 275 143 L 278 141" stroke="#FFFFFF" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>

            {/* Desk */}
            <rect x="80" y="245" width="180" height="6" fill="#1E293B"/>
            <rect x="90" y="251" width="6" height="40" fill="#1E293B"/>
            <rect x="244" y="251" width="6" height="40" fill="#1E293B"/>
            <path d="M 120 240 L 220 240 L 230 250 L 110 250 Z" fill="#CBD5E1"/>

            {/* Laptop */}
            <rect x="128" y="195" width="84" height="48" rx="2" fill="#1E293B"/>
            <rect x="131" y="198" width="78" height="42" rx="1" fill="#FFFFFF"/>
            <rect x="134" y="201" width="72" height="8" fill="#DCFCE7"/>
            <text x="137" y="207" fontSize="5" fontWeight="700" fill="#0F6E56">● Deposit landed, $312</text>
            <rect x="134" y="212" width="72" height="6" fill="#F7F8FA"/>
            <rect x="134" y="221" width="72" height="6" fill="#F7F8FA"/>
            <rect x="134" y="230" width="40" height="6" fill="#15A08C"/>

            {/* Lady figure */}
            <rect x="150" y="245" width="50" height="40" fill="#1E293B"/>
            <path d="M 135 245 Q 135 200 175 195 Q 215 200 215 245 Z" fill="#15A08C"/>
            <path d="M 140 215 Q 125 215 120 230 Q 118 234 122 236 Q 135 230 150 230 Z" fill="#15A08C"/>
            <path d="M 210 215 Q 225 215 230 230 Q 232 234 228 236 Q 215 230 200 230 Z" fill="#15A08C"/>
            <circle cx="122" cy="235" r="6" fill="#8B5A3C"/>
            <circle cx="228" cy="235" r="6" fill="#8B5A3C"/>
            <rect x="170" y="178" width="10" height="18" fill="#8B5A3C"/>
            <circle cx="175" cy="165" r="22" fill="#8B5A3C"/>
            <path d="M 153 162 Q 153 142 175 138 Q 197 142 197 162 Q 197 155 190 150 Q 180 145 175 145 Q 165 145 160 150 Q 153 155 153 162 Z" fill="#1E1B4B"/>
            <circle cx="195" cy="148" r="8" fill="#1E1B4B"/>
            <circle cx="168" cy="166" r="4" fill="none" stroke="#1E293B" strokeWidth="1.2"/>
            <circle cx="182" cy="166" r="4" fill="none" stroke="#1E293B" strokeWidth="1.2"/>
            <line x1="172" y1="166" x2="178" y2="166" stroke="#1E293B" strokeWidth="1.2"/>
            <path d="M 170 174 Q 175 177 180 174" stroke="#1E293B" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
          </svg>
        </div>
        <div style={COPY}>
          <h2 style={COPY_H2}>Watch the money land.</h2>
          <p style={COPY_P}>Every card, bank, and Interac payment routed through Novala Pay shows up here on the day it lands in your bank, with the invoice it came from.</p>
          <div style={STEPS}>
            {steps.map((s, i) => (
              <div key={i} style={STEP}>
                <span style={STEP_N}>{i + 1}</span>
                <div>
                  <div style={{ fontWeight: 700 }}>{s.b}</div>
                  <div style={{ color: '#66748B', fontSize: 13 }}>{s.d}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button type="button" style={BTN}>Turn on Novala Pay</button>
            <button type="button" style={BTN_GHOST}>See payout schedule</button>
          </div>
        </div>
      </div>
    </div>
  );
}